export default __webpack_public_path__ + "static/codingpark-web-ide-min-ca698974081b5fbf6538a677a2a18b0a.png";